import { GlobalStylesProps } from '@mui/material';
import { theme } from './theme';

export const globalStyle: GlobalStylesProps['styles'] = `
body {
  margin: 0;
  background: ${theme.palette.screenBackground.main};
  min-width: ${theme.breakpoints.values.xs}px;
}

* :not(.api-explorer *) {
  box-sizing: border-box;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
}

#cc-main > .api-explorer {
  height: calc(100vh - var(--main-tabs-height) - var(--main-footer-height));
}

/**
 * Override the 'border-box' above for API explorer dialogs
 * which are rendered as direct children of 'body', not '.api-explorer'
 */
.graphiql-dialog-header button svg {
  box-sizing: inherit;
}

h1 {
  font-size: '2.125rem';
  line-height: '1.2';
  text-align: 'left';
}

.recharts-pie-sector:focus {
  outline: none;
}

// BEGIN
// Main layout properties

:root {
  --main-tabs-height: 3.75rem;
  --main-footer-height: 3.5rem;
  --secondary-tabs-height: 3rem;
  --secondary-outlet-px: 1.5rem;
  --secondary-outlet-py: 1rem;
}

#cc-navbar {
  position: sticky;
  height: var(--main-tabs-height);
  z-index: 100;
  top: 0;
}

#cc-navbar .MuiTab-root {
  min-height: var(--main-tabs-height);
  height: var(--main-tabs-height);
}

#cc-main {
  min-height: calc(100vh - var(--main-tabs-height) - var(--main-footer-height));
}

#cc-secondary-nav {
  height: 100%;
  overflow-y: auto;
}

#cc-secondary-navtabs {
  position: sticky;
  top: 0;
  z-index: 3;
}

#cc-secondary-navtabs .MuiTab-root {
  min-height: var(--secondary-tabs-height);
  height: var(--secondary-tabs-height);
}

// END

// remove json-viewer opacity
.data-key {
  opacity: 1 !important;
}
`;
